<template>
  <span
    class="nav-link sidenav-nav-link"
    role="button"
    tabindex="0"
    v-bind="$attrs"
    @click="goTo"
    @keydown.enter.prevent="goTo"
    @keydown.space.prevent="goTo"
  >
    <div
      class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
    >
      <slot name="icon"></slot>
    </div>
    <span
      class="nav-link-text"
      :class="this.$store.state.isRTL ? ' me-1' : 'ms-1'"
      >{{ navText }}</span
    >
  </span>
</template>
<script>
export default {
  name: "sidenav-item",
  props: {
    url: {
      type: String,
      required: true
    },
    navText: {
      type: String,
      required: true
    }
  },
  methods: {
    goTo() {
      const target = this.url;
      if (this.$route.path !== target) {
        this.$router.push(target).catch(() => {});
      }
    }
  }
};
</script>
<style scoped>
.sidenav-nav-link {
  display: flex;
  align-items: center;
  cursor: pointer;
  outline: none;
}
.sidenav-nav-link:focus {
  outline: none;
}
</style>
